import React, { useState } from 'react';
import Button from '@shared/ui/Button';
import ReportProblemDialog from './ReportProblemDialog';

export interface ReportProblemLinkProps {
  entityType: 'person' | 'committee' | 'ballot_measure' | 'other';
  entityId?: string | null;
  /** Pre-selects "Which part?" in the dialog (e.g. 'campaign_money'). */
  section?: string;
  pageTitle?: string;
  className?: string;
  /** Overrides the default "Report a problem" text. */
  children?: React.ReactNode;
}

/**
 * Inline "Report a problem" text link that opens <ReportProblemDialog>
 * (citizen person page & committee card PRD §5.13). Renders through the shared
 * Button so it stays a real, focusable button, styled as an underlined link
 * that takes its color from the surrounding text unless `className` says
 * otherwise.
 */
const ReportProblemLink: React.FC<ReportProblemLinkProps> = ({
  entityType,
  entityId,
  section,
  pageTitle,
  className = '',
  children,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="ghost"
        size="sm"
        noShadow
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        className={`min-h-[44px] !px-0 !py-0 ![color:inherit] underline underline-offset-2 hover:!bg-transparent hover:no-underline ${className}`}
      >
        {children ?? 'Report a problem'}
      </Button>
      <ReportProblemDialog
        isOpen={open}
        onClose={() => setOpen(false)}
        entityType={entityType}
        entityId={entityId}
        section={section}
        pageTitle={pageTitle}
      />
    </>
  );
};

export default ReportProblemLink;
